import type { BoosterType, Rarity } from '@anidex/shared/economy';
import { LogoPlate } from '../../components/Brand';
import { boosterShortName } from '../../i18n/catalog';

interface BoosterPackProps {
  type: BoosterType;
  name: string;
  size?: 'sm' | 'md' | 'lg';
  state?: 'idle' | 'charging' | 'tearing';
  disabled?: boolean;
}

export function BoosterPack({ type, name, size = 'md', state = 'idle', disabled = false }: BoosterPackProps) {
  return (
    <span className={`pack pack--${type} pack--${size} pack--${state}${disabled ? ' pack--disabled' : ''}`} aria-hidden="true">
      <span className="pack__top">
        <span className="pack__crimp" />
      </span>
      <span className="pack__foil" />
      <span className="pack__emblem">
        <LogoPlate size="sm" />
      </span>
      <span className="pack__name">{boosterShortName(type, name)}</span>
      <span className="pack__crimp pack__crimp--bottom" />
    </span>
  );
}


export function CardBack({ rarity }: { rarity?: Rarity }) {
  const tease = rarity === 'legendary' || rarity === 'mythic' || rarity === 'divine';
  return (
    <span className={`card-back${tease ? ` card-back--${rarity}` : ''}`}>
      <span className="card-back__pattern" />
      {rarity === 'mythic' && <MythicCracks />}
      {rarity === 'legendary' && (
        <span className="card-back__tease" aria-hidden="true">
          <i />
          <i />
          <i />
          <i />
        </span>
      )}
      {rarity === 'divine' && <span className="card-back__leak" aria-hidden="true" />}
      <span className="card-back__emblem">
        <LogoPlate size="sm" />
      </span>
    </span>
  );
}

function MythicCracks() {
  return (
    <svg className="card-back__cracks" viewBox="0 0 100 140" preserveAspectRatio="none" aria-hidden="true">
      <path d="M50 0 L46 28 L58 40 L44 70 L62 88 L48 140" />
      <path d="M44 70 L18 80 L6 112" />
      <path d="M62 88 L84 98 L96 124" />
      <path className="is-hot" d="M51 0 L47 28 L59 40 L45 70 L63 88 L49 140" />
    </svg>
  );
}
